// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Auto-Fill Field Suggestion Component Styles
 * Displays suggestions right below individual fields
 */

.auto-fill-field-suggestion {
    margin-top: var(--space-2);
    animation: slideInDown 0.3s ease-out;
}

.field-suggestion-loading {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-3);
    background: var(--info-50);
    border: 1px solid var(--info-200);
    border-radius: var(--radius-md);
    color: var(--info-700);
    font-size: var(--text-sm);
}

.field-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--info-200);
    border-top: 2px solid var(--info-600);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.field-suggestion-content {
    background: linear-gradient(135deg, var(--info-50) 0%, var(--info-100) 100%);
    border: 1px solid var(--info-200);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    position: relative;
}

.field-suggestion-content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--primary-500), var(--success-500));
    border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.field-suggestion-header {
    background: linear-gradient(135deg, var(--info-100) 0%, var(--info-200) 100%);
    padding: var(--space-2) var(--space-3);
    border-bottom: 1px solid var(--info-200);
}

.field-suggestion-title {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-weight: var(--font-weight-medium);
    color: var(--info-800);
    font-size: var(--text-sm);
}

.field-icon {
    font-size: var(--text-base);
    opacity: 0.8;
}

.suggestion-count {
    background: var(--info-100);
    color: var(--info-700);
    padding: 2px 6px;
    border-radius: var(--radius-sm);
    font-size: var(--text-xs);
    font-weight: var(--font-weight-medium);
}

.field-suggestion-items {
    padding: var(--space-2);
}

.field-suggestion-item {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    padding: var(--space-3);
    background: white;
    border: 1px solid var(--neutral-200);
    border-radius: var(--radius-md);
    margin-bottom: var(--space-2);
    transition: all var(--transition-base);
}

.field-suggestion-item:last-child {
    margin-bottom: 0;
}

.field-suggestion-item:hover {
    border-color: var(--info-300);
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
}

.field-suggestion-main {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
}

.field-suggestion-label {
    display: flex;
    align-items: center;
    gap: var(--space-1);
    font-size: var(--text-xs);
    font-weight: var(--font-weight-medium);
    color: var(--neutral-600);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-icon-small {
    font-size: var(--text-sm);
    opacity: 0.7;
}

.field-name {
    font-size: var(--text-xs);
}

.field-suggestion-value {
    color: var(--neutral-800);
    font-size: var(--text-sm);
    font-family: var(--font-family-mono);
    background: var(--neutral-50);
    padding: var(--space-2);
    border-radius: var(--radius-sm);
    border: 1px solid var(--neutral-200);
    word-break: break-word;
}

.field-suggestion-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--space-2);
}

.field-suggestion-item.applied {
    border-color: var(--success-300);
    background: var(--success-50);
}

.field-suggestion-item.ignored {
    border-color: var(--error-300);
    background: var(--error-50);
    opacity: 0.7;
}

.field-suggestion-info {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    flex: 1 1;
    min-width: 0;
}

.field-suggestion-value {
    color: var(--neutral-700);
    font-size: var(--text-sm);
    font-family: var(--font-family-mono);
    background: var(--neutral-100);
    padding: var(--space-1) var(--space-2);
    border-radius: var(--radius-sm);
    border: 1px solid var(--neutral-200);
    word-break: break-word;
    flex: 1 1;
}

.field-confidence-badge {
    padding: 2px 6px;
    border-radius: var(--radius-sm);
    font-size: var(--text-xs);
    font-weight: var(--font-weight-medium);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

.confidence-high {
    background: var(--success-100);
    color: var(--success-700);
}

.confidence-medium {
    background: var(--warning-100);
    color: var(--warning-700);
}

.confidence-low {
    background: var(--error-100);
    color: var(--error-700);
}

.field-suggestion-actions {
    display: flex;
    gap: var(--space-1);
    align-items: center;
    flex-shrink: 0;
}

.field-btn-apply,
.field-btn-ignore {
    padding: var(--space-1) var(--space-2);
    border: none;
    border-radius: var(--radius-sm);
    font-size: var(--text-xs);
    font-weight: var(--font-weight-medium);
    cursor: pointer;
    transition: all var(--transition-base);
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    height: 28px;
}

.field-btn-apply {
    background: linear-gradient(135deg, var(--success-100) 0%, var(--success-200) 100%);
    color: var(--success-700);
    border: 1px solid var(--success-300);
}

.field-btn-apply:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--success-200) 0%, var(--success-300) 100%);
    color: var(--success-800);
    transform: scale(1.1);
}

.field-btn-ignore {
    background: linear-gradient(135deg, var(--error-100) 0%, var(--error-200) 100%);
    color: var(--error-700);
    border: 1px solid var(--error-300);
}

.field-btn-ignore:hover:not(:disabled) {
    background: linear-gradient(135deg, var(--error-200) 0%, var(--error-300) 100%);
    color: var(--error-800);
    transform: scale(1.1);
}

.field-btn-apply:disabled,
.field-btn-ignore:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* Animations */
@keyframes slideInDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .field-suggestion-item {
        padding: var(--space-2);
    }

    .field-suggestion-meta {
        flex-direction: column;
        align-items: stretch;
        gap: var(--space-2);
    }

    .field-suggestion-actions {
        justify-content: center;
        gap: var(--space-2);
    }

    .field-suggestion-value {
        font-size: var(--text-xs);
    }

    .field-btn-apply,
    .field-btn-ignore {
        flex: 1 1;
        min-width: auto;
    }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .field-suggestion-loading {
        background: var(--neutral-800);
        border-color: var(--neutral-700);
        color: var(--neutral-300);
    }

    .field-suggestion-content {
        background: linear-gradient(135deg, var(--neutral-800) 0%, var(--neutral-900) 100%);
        border-color: var(--neutral-700);
    }

    .field-suggestion-content::before {
        background: linear-gradient(90deg, var(--primary-600), var(--success-600));
    }

    .field-suggestion-header {
        background: linear-gradient(135deg, var(--neutral-700) 0%, var(--neutral-800) 100%);
        border-color: var(--neutral-600);
    }

    .field-suggestion-title {
        color: var(--neutral-200);
    }

    .field-suggestion-item {
        background: var(--neutral-700);
        border-color: var(--neutral-600);
    }

    .field-suggestion-item.applied {
        background: var(--success-900);
        border-color: var(--success-600);
    }

    .field-suggestion-item.ignored {
        background: var(--error-900);
        border-color: var(--error-600);
    }

    .field-suggestion-value {
        background: var(--neutral-600);
        border-color: var(--neutral-500);
        color: var(--neutral-200);
    }

    .confidence-high {
        background: var(--success-800);
        color: var(--success-200);
    }

    .confidence-medium {
        background: var(--warning-800);
        color: var(--warning-200);
    }

    .confidence-low {
        background: var(--error-800);
        color: var(--error-200);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/AutoFillFieldSuggestion.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;IACI,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,iCAAiC;IACjC,+BAA+B;IAC/B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,4EAA4E;IAC5E,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,0EAA0E;IAC1E,oDAAoD;AACxD;;AAEA;IACI,6EAA6E;IAC7E,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oCAAoC;IACpC,+BAA+B;IAC/B,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,oCAAoC;IACpC,8BAA8B;IAC9B,sCAAsC;IACtC,+BAA+B;IAC/B,oCAAoC;IACpC,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,sCAAsC;IACtC,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,sCAAsC;IACtC,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mFAAmF;IACnF,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,mFAAmF;IACnF,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+EAA+E;IAC/E,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,+EAA+E;IAC/E,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,SAAO;QACP,eAAe;IACnB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,8BAA8B;QAC9B,gCAAgC;QAChC,yBAAyB;IAC7B;;IAEA;QACI,mFAAmF;QACnF,gCAAgC;IACpC;;IAEA;QACI,0EAA0E;IAC9E;;IAEA;QACI,mFAAmF;QACnF,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;QAC9B,gCAAgC;QAChC,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;QAC5B,uBAAuB;IAC3B;AACJ","sourcesContent":["/**\n * Auto-Fill Field Suggestion Component Styles\n * Displays suggestions right below individual fields\n */\n\n.auto-fill-field-suggestion {\n    margin-top: var(--space-2);\n    animation: slideInDown 0.3s ease-out;\n}\n\n.field-suggestion-loading {\n    display: flex;\n    align-items: center;\n    gap: var(--space-2);\n    padding: var(--space-3);\n    background: var(--info-50);\n    border: 1px solid var(--info-200);\n    border-radius: var(--radius-md);\n    color: var(--info-700);\n    font-size: var(--text-sm);\n}\n\n.field-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid var(--info-200);\n    border-top: 2px solid var(--info-600);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n.field-suggestion-content {\n    background: linear-gradient(135deg, var(--info-50) 0%, var(--info-100) 100%);\n    border: 1px solid var(--info-200);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    overflow: hidden;\n    position: relative;\n}\n\n.field-suggestion-content::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, var(--primary-500), var(--success-500));\n    border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n\n.field-suggestion-header {\n    background: linear-gradient(135deg, var(--info-100) 0%, var(--info-200) 100%);\n    padding: var(--space-2) var(--space-3);\n    border-bottom: 1px solid var(--info-200);\n}\n\n.field-suggestion-title {\n    display: flex;\n    align-items: center;\n    gap: var(--space-2);\n    font-weight: var(--font-weight-medium);\n    color: var(--info-800);\n    font-size: var(--text-sm);\n}\n\n.field-icon {\n    font-size: var(--text-base);\n    opacity: 0.8;\n}\n\n.suggestion-count {\n    background: var(--info-100);\n    color: var(--info-700);\n    padding: 2px 6px;\n    border-radius: var(--radius-sm);\n    font-size: var(--text-xs);\n    font-weight: var(--font-weight-medium);\n}\n\n.field-suggestion-items {\n    padding: var(--space-2);\n}\n\n.field-suggestion-item {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2);\n    padding: var(--space-3);\n    background: white;\n    border: 1px solid var(--neutral-200);\n    border-radius: var(--radius-md);\n    margin-bottom: var(--space-2);\n    transition: all var(--transition-base);\n}\n\n.field-suggestion-item:last-child {\n    margin-bottom: 0;\n}\n\n.field-suggestion-item:hover {\n    border-color: var(--info-300);\n    box-shadow: var(--shadow-sm);\n    transform: translateY(-1px);\n}\n\n.field-suggestion-main {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-1);\n}\n\n.field-suggestion-label {\n    display: flex;\n    align-items: center;\n    gap: var(--space-1);\n    font-size: var(--text-xs);\n    font-weight: var(--font-weight-medium);\n    color: var(--neutral-600);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.field-icon-small {\n    font-size: var(--text-sm);\n    opacity: 0.7;\n}\n\n.field-name {\n    font-size: var(--text-xs);\n}\n\n.field-suggestion-value {\n    color: var(--neutral-800);\n    font-size: var(--text-sm);\n    font-family: var(--font-family-mono);\n    background: var(--neutral-50);\n    padding: var(--space-2);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--neutral-200);\n    word-break: break-word;\n}\n\n.field-suggestion-meta {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--space-2);\n}\n\n.field-suggestion-item.applied {\n    border-color: var(--success-300);\n    background: var(--success-50);\n}\n\n.field-suggestion-item.ignored {\n    border-color: var(--error-300);\n    background: var(--error-50);\n    opacity: 0.7;\n}\n\n.field-suggestion-info {\n    display: flex;\n    align-items: center;\n    gap: var(--space-2);\n    flex: 1;\n    min-width: 0;\n}\n\n.field-suggestion-value {\n    color: var(--neutral-700);\n    font-size: var(--text-sm);\n    font-family: var(--font-family-mono);\n    background: var(--neutral-100);\n    padding: var(--space-1) var(--space-2);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--neutral-200);\n    word-break: break-word;\n    flex: 1;\n}\n\n.field-confidence-badge {\n    padding: 2px 6px;\n    border-radius: var(--radius-sm);\n    font-size: var(--text-xs);\n    font-weight: var(--font-weight-medium);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    flex-shrink: 0;\n}\n\n.confidence-high {\n    background: var(--success-100);\n    color: var(--success-700);\n}\n\n.confidence-medium {\n    background: var(--warning-100);\n    color: var(--warning-700);\n}\n\n.confidence-low {\n    background: var(--error-100);\n    color: var(--error-700);\n}\n\n.field-suggestion-actions {\n    display: flex;\n    gap: var(--space-1);\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.field-btn-apply,\n.field-btn-ignore {\n    padding: var(--space-1) var(--space-2);\n    border: none;\n    border-radius: var(--radius-sm);\n    font-size: var(--text-xs);\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    transition: all var(--transition-base);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 60px;\n    height: 28px;\n}\n\n.field-btn-apply {\n    background: linear-gradient(135deg, var(--success-100) 0%, var(--success-200) 100%);\n    color: var(--success-700);\n    border: 1px solid var(--success-300);\n}\n\n.field-btn-apply:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--success-200) 0%, var(--success-300) 100%);\n    color: var(--success-800);\n    transform: scale(1.1);\n}\n\n.field-btn-ignore {\n    background: linear-gradient(135deg, var(--error-100) 0%, var(--error-200) 100%);\n    color: var(--error-700);\n    border: 1px solid var(--error-300);\n}\n\n.field-btn-ignore:hover:not(:disabled) {\n    background: linear-gradient(135deg, var(--error-200) 0%, var(--error-300) 100%);\n    color: var(--error-800);\n    transform: scale(1.1);\n}\n\n.field-btn-apply:disabled,\n.field-btn-ignore:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Animations */\n@keyframes slideInDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .field-suggestion-item {\n        padding: var(--space-2);\n    }\n\n    .field-suggestion-meta {\n        flex-direction: column;\n        align-items: stretch;\n        gap: var(--space-2);\n    }\n\n    .field-suggestion-actions {\n        justify-content: center;\n        gap: var(--space-2);\n    }\n\n    .field-suggestion-value {\n        font-size: var(--text-xs);\n    }\n\n    .field-btn-apply,\n    .field-btn-ignore {\n        flex: 1;\n        min-width: auto;\n    }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n    .field-suggestion-loading {\n        background: var(--neutral-800);\n        border-color: var(--neutral-700);\n        color: var(--neutral-300);\n    }\n\n    .field-suggestion-content {\n        background: linear-gradient(135deg, var(--neutral-800) 0%, var(--neutral-900) 100%);\n        border-color: var(--neutral-700);\n    }\n\n    .field-suggestion-content::before {\n        background: linear-gradient(90deg, var(--primary-600), var(--success-600));\n    }\n\n    .field-suggestion-header {\n        background: linear-gradient(135deg, var(--neutral-700) 0%, var(--neutral-800) 100%);\n        border-color: var(--neutral-600);\n    }\n\n    .field-suggestion-title {\n        color: var(--neutral-200);\n    }\n\n    .field-suggestion-item {\n        background: var(--neutral-700);\n        border-color: var(--neutral-600);\n    }\n\n    .field-suggestion-item.applied {\n        background: var(--success-900);\n        border-color: var(--success-600);\n    }\n\n    .field-suggestion-item.ignored {\n        background: var(--error-900);\n        border-color: var(--error-600);\n    }\n\n    .field-suggestion-value {\n        background: var(--neutral-600);\n        border-color: var(--neutral-500);\n        color: var(--neutral-200);\n    }\n\n    .confidence-high {\n        background: var(--success-800);\n        color: var(--success-200);\n    }\n\n    .confidence-medium {\n        background: var(--warning-800);\n        color: var(--warning-200);\n    }\n\n    .confidence-low {\n        background: var(--error-800);\n        color: var(--error-200);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
